import { useQuery } from '@tanstack/react-query';

import { createQueryKeys } from '@lemon/shared';

import { fetchGoodsById } from '../api';

import type { FetchGoodsParams } from '../api';
import type { ProductView } from '@lemoncloud/epyt-goods-api';

export const goodsKeys = createQueryKeys('goods');

export const useGoods = (id?: FetchGoodsParams['id']) => {
    const keyId = String(id ?? '').trim();

    return useQuery<ProductView>({
        queryKey: goodsKeys.detail(keyId),
        queryFn: () => fetchGoodsById({ id: keyId }),
        refetchOnWindowFocus: false,
        enabled: !!keyId,
    });
};
